export const ADD_CUSTOMER_DETAILS = "ADD_CUSTOMER_DETAILS";
export const FETCH_CUSTOMER_DETAILS_LIST = "FETCH_CUSTOMER_DETAILS_LIST";
export const EDIT_CUSTOMER_DETAILS = "EDIT_CUSTOMER_DETAILS";
export const UPDATE_CUSTOMER_DETAILS = "UPDATE_CUSTOMER_DETAILS";
export const DELETE_CUSTOMER_DETAILS = "DELETE_CUSTOMER_DETAILS";
